import { FC, memo, useCallback, useEffect, useState } from 'react';
import { useAppSelector } from '../../core/redux/hooks/useAppSelector';
import { selectGameType } from '../../modules/game/selectors';
import FragmentsButton from '../../modules/fragments/components/FragmentsButton';
import styles from './styles.module.scss';
import MetroButton from '../../modules/metro/components/MetroButton';
import classNames from 'classnames';
import { useLocalStorage } from 'react-use';
import FragmentsRulesModal from '../../modules/fragments/components/RulesModal';
import MetroRulesModal from '../../modules/metro/components/RulesModal';

type TRulesButtonProps = {
  className?: string;
  onOpenModal?: VoidFunction;
  onCloseModal?: VoidFunction;
};

const RulesButton: FC<TRulesButtonProps> = memo(({ className, onOpenModal, onCloseModal }) => {
  const gameType = useAppSelector(selectGameType);
  const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);
  const [hintShown, setHintShown] = useLocalStorage<boolean>(`${gameType}RulesModalShown`, false);

  const handleOpenModal = useCallback(() => {
    setIsRulesModalOpen(true);
    onOpenModal?.();
  }, [onOpenModal]);

  const handleModalClose = useCallback(() => {
    setHintShown(true);
    setIsRulesModalOpen(false);
    onCloseModal?.();
  }, [onCloseModal, setHintShown]);

  useEffect(() => {
    if (!hintShown) {
      setIsRulesModalOpen(true);
    }
  }, [hintShown]);

  return (
    <>
      {gameType === 'fragments' && (
        <>
          <FragmentsButton
            className={classNames(styles.fragments, className)}
            color="yellow"
            onClick={handleOpenModal}
            icon="QuestionMark"
          />

          {isRulesModalOpen && <FragmentsRulesModal onClose={handleModalClose} />}
        </>
      )}

      {gameType === 'metro' && (
        <>
          <MetroButton className={classNames(styles.metro, className)} onClick={handleOpenModal} icon="QuestionMark" />
          {isRulesModalOpen && <MetroRulesModal onClose={handleModalClose} />}
        </>
      )}
    </>
  );
});

export default RulesButton;
